













import { AccountFlagNames } from '@modules/userProfile/account/FeatureFlags';
import { AdditionalDepositButtonType } from '@core/models/user/flags';
import { RouteName } from '@app/router/constants/RouteName';
import { TicketRoutes } from '@superbet-group/web.types';
import { SdsButton } from '@superbet-group/web.lib.ui-components';
import { Analytics as AnalyticsSDK } from '@superbet-group/web.analytics.sdk';
import { BetSlipModule } from '@store/modules/ui/sportOffer/betslip';
import { ModalStore } from '@store/modules/ui/shared/modal/modalIndex';
import authStore from '@store/modules/data/authentication/authenticationIndex';
import helpUIStoreIndex from '@store/modules/ui/help/helpIndex';
import {
    computed,
    defineComponent,
    onMounted,
    ref,
} from '@vue/composition-api';
import {
    useVueRouter,
    useVuexStore,
    isMobileLayout,
} from '@superbet-group/web.lib.vue-utilities';
import { featureFlagService } from '@superbet-group/web.lib.flags';
import { capitalize } from '@superbet-group/web.lib.utilities';
import modalCodes from '@store/modules/ui/shared/modal/modalCodes';

const enabledRoutes = [
    RouteName.App.Home,
    RouteName.Sport.CategoryPerTime,
    TicketRoutes.MyBets,
];

export default defineComponent({
    name: 'FloatingDepositButton',
    setup() {
        const router = useVueRouter();

        const betSlipStore = useVuexStore<BetSlipModule>('ui/sportOffer/betSlip');
        const authModule = useVuexStore<typeof authStore>('data/authentication');
        const helpUIStore = useVuexStore<typeof helpUIStoreIndex>('ui/help');
        const modalModule = useVuexStore<ModalStore>('ui/modal');

        const isBetSlipEmpty = betSlipStore.getter('isEmpty');

        const authenticatedUser = authModule.getter('user');
        const isUserAuthenticated = computed(() => authenticatedUser.value != null);

        const modal = modalModule.getter('modal');

        const isHelpVisible = helpUIStore.state('isHelpVisible');

        const whichAdditionalDepositButtonEnabled = ref<AdditionalDepositButtonType>(AdditionalDepositButtonType.None);
        const isFloatingDepositButtonEnabled = computed(() => whichAdditionalDepositButtonEnabled.value === AdditionalDepositButtonType.Floating);

        const isRouteEnabled = computed(() => enabledRoutes.includes(router.route.value.name!));
        const isFirstTimeDeposit = computed(() => !authenticatedUser.value?.hasMadeDeposit);
        const hasBetSlipModal = computed(() => modal.value?.code === modalCodes.mobileBetSlip);
        const isBetslipShown = computed(() => isMobileLayout() ? hasBetSlipModal.value : !isBetSlipEmpty.value);

        const isFloatingDepositButtonVisible = computed(() => (
            isRouteEnabled.value
            && isUserAuthenticated.value
            && !isBetslipShown.value
            && !isHelpVisible.value
            && isFirstTimeDeposit.value
            && isFloatingDepositButtonEnabled.value
        ));

        onMounted(async () => {
            whichAdditionalDepositButtonEnabled.value = await featureFlagService.getFeatureValue(
                AccountFlagNames.whichAdditionalDepositButtonShown,
                AdditionalDepositButtonType.None,
            );
        });

        const goToDepositScreen = () => {
            AnalyticsSDK.getInstance().log(
                'Deposit_Option_Chosen',
                {
                    whichOption: 'Floating_button',
                },
            );
            router.pushRoute({ name: RouteName.Account.Deposit });
        };

        return {
            goToDepositScreen,
            isBetSlipEmpty,
            isFloatingDepositButtonVisible,
            capitalize,
        };
    },
    components: {
        SdsButton,
    },
});
